<template>
    <div v-if="statusRows.length > 0">
        <component :is="showCard ? 'v-card' : 'div'">
            <v-card-title v-if="title" class="headline" :class="whiteMode || !showCard ? '' : 'white--text'">
                {{ title }}
            </v-card-title>
            <v-card-text>
                <v-layout row wrap>
                    <v-flex xs12>
                        <div v-for="point in statusRows" :key="point.sensor_id || point.sensor_name" class="mb-2">
                            <strong>{{ point.sensor_name }}</strong>
                            <v-chip v-for="status in point.point_status" :key="status" small class="ma-1">
                                {{ status }}
                            </v-chip>
                        </div>
                    </v-flex>
                </v-layout>
            </v-card-text>
        </component>
    </div>
</template>

<script>
import _ from 'lodash'
import { getPoint } from '../../helper'

export default {
    name: 'PointStatusWidget',
    props: {
        equipment: { type: String, default: null },
        filter: {
            type: Array,
            default: function () {
                return [['ok']]
            },
        },
        filterJson: { type: String, default: null },
        points: { type: Array, default: null },
        title: { type: String, default: null },
        showCard: { type: Boolean, default: true },
        whiteMode: { type: Boolean, default: false },
    },
    data: function () {
        return {
            loadedPoints: [],
            requestId: 0,
        }
    },
    computed: {
        effectiveFilter() {
            if (!this.filterJson) return this.filter
            try {
                const parsedFilter = JSON.parse(this.filterJson)
                return Array.isArray(parsedFilter) && parsedFilter.every(Array.isArray)
                    ? parsedFilter
                    : this.filter
            } catch (error) {
                return this.filter
            }
        },
        sourcePoints() {
            return this.points === null ? this.loadedPoints : this.points
        },
        statusRows() {
            if (!this.equipment) return []

            return this.sourcePoints
                .filter(point => point.equipment_name === this.equipment)
                .filter(point => point.meta && Array.isArray(point.meta.point_status))
                .filter(point => !this.effectiveFilter.some(filteredStatus => _.isEqual(point.meta.point_status, filteredStatus)))
                .map(point => ({
                    sensor_id: point.sensor_id,
                    sensor_name: point.sensor_name,
                    point_status: point.meta.point_status,
                }))
        },
    },
    watch: {
        equipment() {
            this.loadPoints()
        },
        points() {
            this.loadPoints()
        },
    },
    mounted() {
        this.loadPoints()
    },
    methods: {
        async loadPoints() {
            const requestId = ++this.requestId
            this.loadedPoints = []
            if (this.points !== null || !this.equipment) return

            const facilityName = this.$store.state.pointsListStore.pointsList.facility_name
            const response = await getPoint({
                facility_name: facilityName,
                equipment_name: this.equipment,
            })
            if (requestId === this.requestId) {
                this.loadedPoints = response.result || []
            }
        },
    },
}
</script>